import React from 'react';
import { motion } from 'framer-motion';
import { Star, ShieldCheck, MapPin } from 'lucide-react';
import { Companion } from '../data/mockData';
interface CompanionCardProps {
  companion: Companion;
  index: number;
}
export function CompanionCard({
  companion,
  index
}: CompanionCardProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} transition={{
    duration: 0.5,
    delay: index * 0.1
  }} className="group relative bg-dark-800 rounded-lg overflow-hidden border border-white/5 hover:border-gold-500/50 transition-all duration-300" data-id="element-81">
      {/* Image Container */}
      <div className="relative aspect-[3/4] overflow-hidden" data-id="element-82">
        <img src={companion.imageUrl} alt={companion.name} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" data-id="element-83" />
        <div className="absolute inset-0 bg-gradient-to-t from-dark-900 via-transparent to-transparent opacity-80" data-id="element-84"></div>

        {/* Verified Badge */}
        {companion.verified && <div className="absolute top-3 left-3 bg-gold-500/90 backdrop-blur-sm text-dark-900 text-xs font-bold px-2 py-1 rounded flex items-center" data-id="element-85">
            <ShieldCheck className="w-3 h-3 mr-1" data-id="element-86" />
            已核验
          </div>}

        {/* Hover Overlay Button */}
        <div className="absolute inset-0 bg-dark-900/40 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center" data-id="element-87">
          <button className="bg-gold-500 text-dark-900 px-6 py-2 rounded font-medium transform translate-y-4 group-hover:translate-y-0 transition-transform duration-300" data-id="element-88">
            查看详情
          </button>
        </div>
      </div>

      {/* Content */}
      <div className="p-4 relative" data-id="element-89">
        <div className="flex justify-between items-start mb-2" data-id="element-90">
          <div data-id="element-91">
            <h3 className="text-lg font-serif font-bold text-white group-hover:text-gold-500 transition-colors" data-id="element-92">
              {companion.name}
            </h3>
            <div className="flex items-center text-xs text-gray-400 mt-1" data-id="element-93">
              <span className="mr-2" data-id="element-94">{companion.nationality}</span>
              <span data-id="element-95">• {companion.age}岁</span>
            </div>
          </div>
          <div className="flex items-center text-gold-500 text-sm" data-id="element-96">
            <Star className="w-3 h-3 fill-current mr-1" data-id="element-97" />
            {companion.rating}
          </div>
        </div>

        <div className="flex flex-wrap gap-2 mb-3" data-id="element-98">
          <span className="text-xs text-gray-500 bg-white/5 px-2 py-1 rounded" data-id="element-99">
            {companion.height}
          </span>
          <span className="text-xs text-gray-500 bg-white/5 px-2 py-1 rounded" data-id="element-100">
            {companion.measurements}
          </span>
        </div>

        <div className="flex flex-wrap gap-1 mb-4" data-id="element-101">
          {companion.tags.slice(0, 3).map(tag => <span key={tag} className="text-[10px] border border-white/10 text-gray-400 px-2 py-0.5 rounded-full" data-id="element-102">
              {tag}
            </span>)}
        </div>

        <div className="flex justify-between items-center border-t border-white/5 pt-3" data-id="element-103">
          <div className="text-gold-500 font-medium" data-id="element-104">{companion.price}</div>
          <div className="flex items-center text-xs text-gray-500" data-id="element-105">
            <MapPin className="w-3 h-3 mr-1" data-id="element-106" />
            Singapore
          </div>
        </div>
      </div>
    </motion.div>;
}